import { FC } from "react";

export const Spinner: FC = () => (
    <div>
        <progress className="progress is-primary" max="100">
            30%
        </progress>
    </div>
);
